module.exports = __webpack_public_path__ + "13f6afce8fa447ae0f379a677aa7e0d6.svg";